import { render, staticRenderFns } from "./im-service.vue?vue&type=template&id=49e78e11&"
import script from "./im-service.vue?vue&type=script&lang=ts&"
export * from "./im-service.vue?vue&type=script&lang=ts&"
import style0 from "./im-service.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports